import { Children, cloneElement, FC, ReactElement } from 'react';
import { useTheme } from 'styled-components';

import { useContextMediaQuery } from '@core/context';
import { ThemeProps } from '@core/type';

import { GridProps } from '../grid/interface-grid';
import { Box } from '../layout/Box';
import { Line } from '../line/Line';
import { TableProps } from './interface-table';

export const Table: FC<TableProps> = ({
  children,
  hasLastLine = true,
  hasLineBetween = true,
  isColumn: isColumnProps,
  ...restProps
}) => {
  const { isPhone } = useContextMediaQuery();
  const {
    structure: {
      table: { base: tableThemeProps },
    },
  } = useTheme() as ThemeProps;
  const isColumn = isColumnProps === undefined ? isPhone : isColumnProps;

  const rowsWithProps = Children.map(children, (child) => {
    const childWithProps = child as { props?: { grid?: GridProps } };

    if (childWithProps) {
      return cloneElement(child as ReactElement, {
        isColumn,
        grid: {
          isContainer: true,
          ...restProps,
          ...childWithProps.props?.grid,
        },
      });
    }

    return null;
  });

  const rowsWithLines = Children.toArray(rowsWithProps).reduce((prev, curr, index) => {
    const prevChildWithProps = prev as { props?: { isHeading?: boolean } };
    return [
      prev,
      !(prevChildWithProps?.props?.isHeading && isColumn) && hasLineBetween && (
        <Line key={index} width={'100%'} isFullWidth={isColumn} />
      ),
      curr,
    ];
  });

  return (
    <Box role={'table'} {...tableThemeProps}>
      <Box role={'rowgroup'}>
        {rowsWithLines}
        {hasLastLine && <Line width={'100%'} isFullWidth={isColumn} />}
      </Box>
    </Box>
  );
};
